import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera, Environment } from '@react-three/drei';
import DoorModel from './DoorModel';
import { Suspense } from 'react';

export const Viewer3D = ({ configuration, isOpen = false, autoRotate = false }) => {
  return (
    <Canvas 
      shadows 
      dpr={[1, 2]}
      gl={{ antialias: true, alpha: false }}
    >
      <PerspectiveCamera makeDefault position={[0, 0, 5]} fov={50} />
      <OrbitControls 
        enablePan={false}
        minDistance={3}
        maxDistance={8}
        maxPolarAngle={Math.PI / 2}
        autoRotate={autoRotate}
        autoRotateSpeed={2}
      />
      
      <color attach="background" args={['#F5F5F5']} />
      
      {/* Enhanced lighting for intense reflections and color visibility */}
      <ambientLight intensity={1.2} />
      
      {/* Main key light - intense from top-right front */}
      <directionalLight 
        position={[5, 8, 8]} 
        intensity={2.5}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
      />
      
      {/* Secondary key light from top-left */}
      <directionalLight 
        position={[-5, 6, 6]} 
        intensity={1.8}
      />
      
      {/* Fill light from left side */}
      <directionalLight 
        position={[-6, 3, 2]} 
        intensity={1.2}
      />
      
      {/* Fill light from right side */}
      <directionalLight 
        position={[6, 3, 2]} 
        intensity={1.2}
      />
      
      {/* Rim/back light for edge definition */}
      <directionalLight 
        position={[0, 4, -6]} 
        intensity={1.0}
      />
      
      {/* Front spotlight for direct illumination */}
      <spotLight 
        position={[0, 5, 8]} 
        angle={0.5}
        penumbra={0.5}
        intensity={2.0}
        castShadow
      />
      
      {/* Low fill light from front */}
      <pointLight position={[0, -1, 4]} intensity={0.8} />
      
      {/* Top down light */}
      <pointLight position={[0, 6, 0]} intensity={1.0} />
      
      <Suspense fallback={null}>
        <DoorModel configuration={configuration} isOpen={isOpen} />
      </Suspense>
      
      {/* Ground plane for shadows */}
      <mesh 
        rotation={[-Math.PI / 2, 0, 0]} 
        position={[0, -1.5, 0]} 
        receiveShadow
      >
        <planeGeometry args={[15, 15]} />
        <shadowMaterial opacity={0.15} />
      </mesh>
    </Canvas>
  );
};

export default Viewer3D;
